import axios from "axios";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const httpClient = axios.create({
    // baseURL:  process.env.NODE_ENV === 'development' ? `http://localhost:3005/api/`:`https://api.mydigitalindia.app:3000/api/`,
  // baseURL: `http://localhost:3005/api/`,
  baseURL: `https://api.mydigitalindia.app:3000/api/`,
});
export function setDefaultHeader(headers, value) {
  httpClient.defaults.headers.common[headers] = value;
}
export async function apiCall(
  method,
  url,
  data,
  header = { "Content-Type": "application/json" }
) {
  try {
    // if (!data?.isLoadMore) {
    //     window.document.getElementById("loaderoverlay").style.display = "none";
    // }
    // console.log('url: vvvvvvvvvvvvvll ', url);
    let res = await httpClient({
      method,
      url,
      data,
      headers: header,
    });
    if (res) {
      // setTimeout(() => {
      //     window.document.getElementById("loaderoverlay").style.display = "none";
      // }, 1000);
      return res;
    }
    if (res.status === 404) {
      res = { data: { error: true, message: res.message } };
    }
    // console.log('res: ', res);
  } catch (error) {
    let errorResponse = {
      data: {
        error: true,
        message: "Internal server error. Please try again!",
      },
    };
    if (error.response) {
      errorResponse = error.response;
    }
    return errorResponse;
  }
}
export const successMessage = (msg) => {
  toast.success(msg, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
  });
};

export const failedMessage = (msg) => {
  toast.error(msg, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
  });
};
export const warnMessage = (msg) => {
  toast.warn(msg, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
  });
};
export const infoMessage = (msg) => {
  toast.info(msg, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
  });
};
